<template>
    <div class="paymentbreakdown">
        <div class="paymentbreakdown__title">Payment Breakdown</div>
        <div class="paymentbreakdown__content">
            <div class="contentbody" v-if="freight">
                <div class="contentbody__title">Freight</div>
                <div class="row m-0 contentbody__header">
                  <div class="col-md-2 p-0 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Description</div>
                  <div class="col-md-1 p-0">QTY</div>
                  <div class="col-md-2 p-0">UOM</div>
                  <div class="col-md-2 p-0" style="padding-left:21px;" v-if="statusShipment !== 0">Unit Price</div>
                  <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Amount</div>
                  <div class="col-md-2 p-0">Note</div>
                </div>
                <div class="contentbody__table"
                    v-for="(item, index) in detail.t_shipmentprices"
                    v-bind:key="`${item.id_price}_${index}`">
                    <div class="row m-0"
                        v-if="item.price_group_code === 'FRE' || item.price_group_code === 'PTP'">
                        <div class="col-md-2 p-0 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_desc }}</div>
                        <div class="col-md-1 p-0">{{ item.qty | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</div>
                        <div class="col-md-2 p-0">{{ getUOM(item.price_uom) }}</div>
                        <div class="col-md-2 p-0" v-if="statusShipment !== 0">{{ item.price / item.qty | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }}</div>
                        <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_sum | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} </div>
                        <div class="col-md-2 p-0 ">{{item.note ? item.note : '-'}}</div>
                    </div>
                </div>
            </div>
            <div class="contentbody" v-if="OLC">
              <div class="contentbody__title">Origin Local Charges</div>
                <div class="row m-0 contentbody__header">
                  <div class="col-md-2 p-0 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Description</div>
                  <div class="col-md-1 p-0">QTY</div>
                  <div class="col-md-2 p-0 ">UOM</div>
                  <div class="col-md-2 p-0" v-if="statusShipment !== 0">Unit Price</div>
                  <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Amount</div>
                  <div class="col-md-2 p-0">Note</div>
                </div>
                <div class="contentbody__table"
                    v-for="(item,index) in detail.t_shipmentprices"
                    v-bind:key="`${index}_${item.id_price}`">
                    <div class="row m-0"
                        v-if="item.price_group_code === 'LOCALCHARGES' || item.price_group_code === 'LCORIGIN' || item.price_group_code === 'OTC' || item.price_group_code === 'OTC' || item.price_group_code === 'OCC' || item.price_group_code === 'OLC' || item.price_group_code === 'ODG' || item.price_group_code === 'TCK' || item.price_group_code === 'TRC'">
                        <div class="col-md-2 p-0 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_desc }}</div>
                        <div class="col-md-1 p-0">{{ item.qty | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</div>
                        <div class="col-md-2 p-0">{{ getUOM(item.price_uom) }}</div>
                        <div class="col-md-2 p-0" v-if="statusShipment !== 0">{{ item.price | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} </div>
                        <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_sum | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} </div>
                        <div class="col-md-2 p-0 ">{{item.note ? item.note : '-'}}</div>
                    </div>
                </div>
            </div>
            <div class="contentbody" v-if="DLC">
                <div class="contentbody__title">Destination Local Charges</div>
                <div class="row m-0 contentbody__header">
                  <div class="col-md-2 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Description</div>
                  <div class="col-md-1 p-0">QTY</div>
                  <div class="col-md-2 p-0">UOM</div>
                  <div class="col-md-2 p-0" v-if="statusShipment !== 0">Unit Price</div>
                  <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Amount</div>
                  <div class="col-md-3 p-0">Note</div>
                </div>
                <div class="contentbody__table"
                    v-for="(item,index) in detail.t_shipmentprices"
                    v-bind:key="`${item.id_price}_${index}`">
                    <div class="row m-0"
                        v-if="item.price_group_code === 'LCDESTINATION' || item.price_group_code === 'DLC' || item.price_group_code === 'DCC' || item.price_group_code === 'DTC' || item.price_group_code === 'DDG'">
                        <div class="col-md-2 p-0 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_desc }}</div>
                        <div class="col-md-1 p-0">{{ item.qty | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</div>
                        <div class="col-md-2 p-0">{{ getUOM(item.price_uom) }}</div>
                        <div class="col-md-2 p-0" v-if="statusShipment !== 0">{{ item.price | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} </div>
                        <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_sum | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} </div>
                        <div class="col-md-2 p-0 ">{{item.note ? item.note : '-'}}</div>
                    </div>
                </div>
            </div>
            <div class="contentbody" v-if="statusShipment !== 0 && Others">
              <div class="contentbody__title">Others</div>
                <div class="row m-0 contentbody__header">
                  <div class="col-md-2 p-0 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Description</div>
                  <div class="col-md-1 p-0">QTY</div>
                  <div class="col-md-2 p-0">UOM</div>
                  <div class="col-md-2 p-0" v-if="statusShipment !== 0">Unit Price</div>
                  <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">Amount</div>
                  <div class="col-md-2 p-0 pl-1  ">Note</div>
                </div>
                <div class="contentbody__table"
                    v-for="(item,index) in detail.t_shipmentprices"
                    v-bind:key="`${index}_${item.id_price}`">
                    <div class="row m-0"
                        v-if="item.price_group_code === 'OTHERS' || item.price_group_code === 'ADJ' || item.price_group_code === 'REI'">
                        <div class="col-md-2 p-0 text-left" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_desc }}</div>
                        <div class="col-md-1 p-0">{{ item.qty | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</div>
                        <div class="col-md-2 p-0">{{ getUOM(item.price_uom) }}</div>
                        <div class="col-md-2 p-0" v-if="statusShipment !== 0">{{ item.price | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} </div>
                        <div class="col-md-3 p-0" :class="statusShipment !== 0 ? 'col-md-2' : 'col-md-3'">{{ item.price_sum | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} </div>
                        <div class="col-md-2 p-0">{{item.note ? item.note : '-' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="paymentbreakdown__footer">
          <div class="row m-0 justify-content-between">
              <p class="col-md-8 text-left pl-1">Sub Total</p>
              <p style="width: 20px;">IDR</p>
              <p class="col-md text-right pl-0">{{ detail.total_gross | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</p>
          </div>
          <div class="row m-0 justify-content-between">
              <p class="col-md-8 text-left pl-1">{{detail.type === 'PPH23' ? 'PPH 23' : 'Tax'}} {{detail.type === 'PPH23' ? `( ${detail.pph23}% )` : `( ${detail.tax}% )`}}</p>
              <p class="amountborder">IDR</p>
              <p class="col-md text-right p-0 mr-3 amountborder" v-if="(detail.type === 'PPH23' && detail.pph23 === 0) || detail.type !== 'PPH23'">{{ detail.total_ppn | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</p>
              <p class="col-md text-right p-0 mr-3 amountborder" v-else>{{- detail.total_ppn  | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</p>
          </div>
          <div class="row m-0 justify-content-between">
              <p class="col-md-8 text-left pl-1">Service Charge Total Amount</p>
              <p style="width: 20px;">IDR</p>
              <p class="col-md text-right pl-0" v-if="detail.type === 'PPH23'">{{ detail ? (detail.total_grand-detail.total_ppn).toFixed(0) : '' | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</p>
              <p class="col-md text-right pl-0" v-else>{{ detail ? (detail.total_grand).toFixed(0) : '' | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</p>
          </div>
          <div class=" align-items-center pt-2 pb-4 pr-4 text-right">
              <span class="">
                <img src="@/assets/image/icon/download-invoice.svg" alt="">
                <u class="" @click.prevent="downloadInvoice(detail.id_shipment, detail.order_number, detail.id, detail.invoice_number)"> Download Invoice</u>
              </span>
          </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StatusUnpaid',
  props: {
    statusShipment: Number
  },
  data () {
    return {
      shipmentId: this.$route.params.shipmentId,
      orderNumber: this.$route.params.orderNumber,
      freight: false,
      OLC: false,
      DLC: false,
      Others: false
    }
  },
  computed: {
    ...mapGetters({
      detail: 'payment/item',
      isLoading: 'payment/isLoading',
      isError: 'payment/error'
    })
  },
  mounted () {
    if (this.detail.t_shipmentprices && this.detail.t_shipmentprices.length > 0) { this.init(this.detail.t_shipmentprices) }
  },
  methods: {
    init (data) {
      data.forEach(item => {
        if (item.price_group_code === 'FRE' || item.price_group_code === 'PTP') {
          this.freight = true
        }
        if (item.price_group_code === 'LOCALCHARGES' || item.price_group_code === 'LCORIGIN' || item.price_group_code === 'OTC' || item.price_group_code === 'OTC' || item.price_group_code === 'OCC' || item.price_group_code === 'OLC' || item.price_group_code === 'ODG' || item.price_group_code === 'TCK' || item.price_group_code === 'TRC') {
          this.OLC = true
        }
        if (item.price_group_code === 'LCDESTINATION' || item.price_group_code === 'DLC' || item.price_group_code === 'DCC' || item.price_group_code === 'DTC' || item.price_group_code === 'DDG') {
          this.DLC = true
        }
        if (item.price_group_code === 'OTHERS' || item.price_group_code === 'ADJ' || item.price_group_code === 'REI') {
          this.Others = true
        }
      })
    },
    getUOM (uom) {
      let uomPrice = 'ALL'
      switch (uom) {
        case 'VW CBM' : uomPrice = 'Per CBM'
          break
        case 'VW KG' : uomPrice = 'Per KG'
          break
        case 'CONT' : uomPrice = 'Per Container'
          break
        case 'ALL DOC' : uomPrice = 'Per Document'
          break
        case 'ALL ITEM' : uomPrice = 'Per Item'
          break
        case 'ALL SHIPMENT' : uomPrice = 'Per Shipment'
          break
        case 'CONT FCL' : uomPrice = 'Per Trip (FCL)'
          break
        case 'ALL TRIP' : uomPrice = 'Per Trip (LCL)'
          break
        case 'AIR TRIP' : uomPrice = 'Per Trip (Air)'
          break
        case 'ALL BOX' : uomPrice = 'Per Box'
          break
        case 'ALL BL' : uomPrice = 'Per BL'
          break
        case 'ALL' : uomPrice = 'Per Item'
          break
        case 'VW' : uomPrice = 'VW'
          break
        case 'WEIGHT' : uomPrice = 'WEIGHT'
          break
        case 'VOL' : uomPrice = 'VOL'
          break
        case 'LCL TRIP' : uomPrice = 'LCL TRIP'
          break
        case 'FCL TRIP' : uomPrice = 'FCL TRIP'
          break
        case 'CW' : uomPrice = 'Per CW'
          break
        case 'ALL M3' : uomPrice = 'Per M3'
          break
        case 'ALL MT' : uomPrice = 'Per MT'
          break
        default : uomPrice = 'ALL'
      }
      return uomPrice
    },
    paymentNow: function () {
      this.$router.push({ name: 'PaymentNow', params: { shipmentId: this.shipmentId, orderNumber: this.orderNumber } })
    },
    fetchPrice () {
      const shipmentId = this.shipmentId
      const orderNumber = this.orderNumber
      this.$store.dispatch('shipment/FETCH_SHIPMENT_PRICE', {shipmentId, orderNumber})
    },
    fetchInvoice () {
      const shipmentId = this.shipmentId
      this.$store.dispatch('shipment/FETCH_SHIPMENT_INVOICE', shipmentId)
    },
    downloadInvoice (idShipment, orderNo, idInvoice, noInvoice) {
      const orderNumber = orderNo.split('/').join('-')
      const fileName = `Invoice-${noInvoice}.pdf`
      this.$store.dispatch('payment/DOWNLOAD_INVOICE', {idShipment, orderNumber, idInvoice, fileName})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment/paymentStatus/StatusUnpaid.vue